import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

const useStyles = makeStyles((theme) =>
    createStyles({
        progressBar: {
            marginTop: '15px'
        },
        shareButton: {
            height: '45px',
            color: 'black !important',
            fontWeight: 'bold',
            fontSize: '1rem !important',
            '&:hover':
                { color: 'white !important' }
        },
        cardButtons: {
            height: '45px',
            textAlign: 'center',
            fontWeight: 'bold',
            color: 'white !important',
            fontSize: '1rem !important'
        }
    }),
);

export default useStyles;